import React from "react";
import Header from "../menu/Header";
import Menu from "../menu/Menu";
import { useEffect , useContext} from "react";
import { TimesList, ExpertTime, SendExpertTime } from "../../../services/kojaServices";
import { useState } from "react";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";
import { toast } from "react-hot-toast";
import { getStandardEnglishNumber } from "./AlphabetUtils";
import { expertContext } from "../../../context/expertcontext";

const Times = () => {
  const [dateList, setDateList] = useState([]);
  const [expertTimes, setExpertTimes] = useState([]);
  const [indexShow, setIndexShow] = useState(0);
  const [newTimes, setNewTimes] = useState([]);
  const [removeId, setRemoveId] = useState([]);
  const { setPage} = useContext(expertContext);


  useEffect(() => {
    const fetchData = async () => {
      try {
        setPage('رزرو زمان')
        const { data } = await ExpertTime();
        setExpertTimes(data.result);
        // console.log(data)
        // console.log(data.result);
        const { data: list } = await TimesList();
        // console.log(list)
        setTimes(list.result, data.result);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []);

  const setTimes = (list, exTime) => {
    let arry = [];
    list.map((i) => {
      i.status = false;
    });
    for (let i = 0; i <= 14; i++) {
      let date = new Date();
      let day = date.getDate();
      date.setDate(day + i);
      let y = {
        date2: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`,
        date: getStandardEnglishNumber(Intl.DateTimeFormat("fa-IR" ,{year:"numeric" , month:"2-digit" , day:"2-digit"}).format(date)).replaceAll("/","-"),
        fa_day: Intl.DateTimeFormat("fa-IR", { weekday: "long" }).format(date),
        day: Intl.DateTimeFormat("en-US", { weekday: "long" }).format(date),
        list: JSON.parse(JSON.stringify(list)),
      };
      // console.log(y)
      arry.push(y);
    }
    // console.log(arry)
    selectedTimes(arry, exTime);
  };

  const selectedTimes = (arry, exTime) => {
    arry.map((i) => {
      exTime.map((t) => {
        if (t.date === i.date2) {
          i.list.map((l, index) => {
            // console.log(l.start?.trim() , t.time)
            if (l.start?.trim() === t.time.trim()) {
              l.status = true;
              l.id = t.id;
            }
          });
        }
      });
    });
    // console.log(arry)
    setDateList(arry);
  };
  const addNewTime = (i, t, index, ind) => {
    let copy = [...dateList];
    let status = copy[index].list[ind].status;
    copy[index].list[ind].status = !status;
    setDateList(copy);
    if (!status) {
      let x = {
        date: i.date2,
        fa_date: i.date,
        fa_day: i.fa_day,
        day: i.day,
        time: t.start,
      };
      let copy = [...newTimes];
      copy.push(x);
      setNewTimes(copy);
      // console.log(x)
    } else {
      let copy = newTimes.filter((item) => {
        if (item.date === i.date2) {
          return item.time !== t.start;
        } else {
          return item.time !== 0;
        }
      });
      setNewTimes(copy);
      console.log(copy);
    }

    if (t.id) {
      let remove = [...removeId];
      remove.push(t.id);
      setRemoveId(remove);
    }
  };


  const AddDay = (target, i,index)=>{
      if(target){
        let copy = [...dateList];
        copy[index].list.map((t)=>{
          t.status = true
        })
        setDateList(copy);
        let copy2 = [...newTimes];
        i.list.map((t)=>{
          let x = {
            date: i.date2,
            fa_date: i.date,
            fa_day: i.fa_day,
            day: i.day,
            time: t.start,
          };
          copy2.push(x);
        })
      setNewTimes(copy2);
      }else{
        let copy = [...dateList];
        copy[index].list.map((t)=>{
          t.status = false
        })
        setDateList(copy);
       
          let copy2 = newTimes.filter((item) =>
            (
              item.date !== i.date2
            )
          );
          setNewTimes(copy2);
          // console.log(copy);
      }
  }

  const sendData = async()=>{
    let datas ={
      newTimes: newTimes,
      removeIds:removeId
    }
    console.log(datas)
    try{
      const {data} = await SendExpertTime(datas)
      console.log(data)
      toast.success('درخواست شما با موفقیت ثبت شد')
      setNewTimes([])
      setRemoveId([])
    }catch(err){
      console.log(err)
      toast.error('خطایی رخ داده، مجدد تلاش کنید')
    }
  }
  const prevDay = () => {
    if (indexShow > 0) {
      setIndexShow(indexShow - 1);
    }
  };

  const nextDay = () => {
    if (indexShow < dateList.length - 1) {
      setIndexShow(indexShow + 1);
    }
  };

  return (
    <div className="" style={{ paddingTop: "10px" }}>
      <Header />
      <div
        className="d-flex request-box-content"
        style={{ margin: "20px 30px 20px 30px" }}
      >
        <Menu />
        <div className="w-100 m-lg-3">
          <div>
            <div className="d-flex justify-content-between">
              <div
                className="d-flex"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  prevDay();
                }}
              >
                <div className="ms-3 arrow-icon">
                  <FaAngleRight />
                </div>
                <p>روز قبل</p>
              </div>
              <div
                className="d-flex"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  nextDay();
                }}
              >
                <p>روز بعد</p>
                <div className="me-3 arrow-icon">
                  <FaAngleLeft />
                </div>
              </div>
            </div>
            <div className="row d-none d-lg-flex">
              {dateList.map(
                (i, index) =>
                  (indexShow === index || indexShow + 1 === index) && (
                    <div
                      key={index}
                      className="col-6 p-2 mt-4"
                      style={{ direction: "rtl" }}
                    >
                      <div className="times-box p-4 text-end">
                        <div className="d-flex justify-content-between">
                          <h4 style={{ color: "#fff" }}>{i.date}</h4>
                          <h4 style={{ color: "#fff" }}>{i.fa_day}</h4>
                          <div className="form-check" style={{ color: "#fff" }}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="checkbox"
                              value={true}
                              disabled ={index ===0 && true}
                              onClick={(e)=>{AddDay(e.target.checked,i,index)}}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="checkbox"
                            >
                              انتخاب همه ساعات
                            </label>
                          </div>
                        </div>
                        <div className="mt-3 row tabel-time">
                          {i.list.map((t, ind) => (
                            <div
                              key={ind}
                              className={
                                t.status ? "col-3 active-time" : "col-3"
                              }
                              onClick={() => {
                                index !==0 && addNewTime(i, t, index, ind);
                              }}
                            >
                              {t.start}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )
              )}
            </div>
            <div className="row  d-lg-none">
              {dateList.map(
                (i, index) =>
                  (indexShow === index || indexShow + 1 === index) && (
                    <div key={index} className="col-12 w-100 p-2 ">
                      <div className="times-box w-100 p-3 text-end">
                        <div className="d-flex justify-content-between">
                          <h6 style={{ color: "#fff" }}>{i.date}</h6>
                          <div className="form-check" style={{ color: "#fff" }}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value=""
                              id="flexCheckDefault"
                              disabled ={index ===0 && true}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="flexCheckDefault"
                            >
                              انتخاب همه ساعات
                            </label>
                          </div>
                        </div>
                        <div className="mt-3 row tabel-time">
                          {i.list.map((t, ind) => (
                            <div
                            key={ind}
                            className={
                              t.status ? "col-3 active-time" : "col-3"
                            }
                            onClick={() => {
                              index !==0 && addNewTime(i, t, index, ind);
                            }}
                          >
                            {t.start}
                          </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )
              )}
            </div>
          </div>
          <div className="mt-3">
            <button
              style={{ width: "250px", height: "60px" }}
              className="new-request-btn btn"
              onClick={()=>{sendData()}}
            >
              ثبت درخواست
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Times;
